/**
 * @file:
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2025/11/07      1.0     First version 财务工作台
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React,{Fragment,PureComponent} from "react";
import Lang from "@/components/Lang/Lang";
import dayjs from 'dayjs';
import { Radio,Spin } from "antd";
import DopIndexAction from "./dopIndex.action";
import {symbolMoneyUtil} from '@utils/utils';
import {isEmpty} from "@utils/utils";
import ReactContext from "@store/reactContext";
import "./dopIndex.less";
export default class MyToDoList  extends PureComponent {
    static contextType = ReactContext;
    constructor(props,context) {
        super(props)
        this.state = {
        }
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }

    /**
     * 财务代办统计
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8532
     */
    getTodo() {
        this.loading(true);
        DopIndexAction.postHttpAction("/service/mg/fin/home/todo",{
        }).then(res=>this.getTodoRes(res.data)).catch(err=>this.getTodoRes(err));
    }
    getTodoRes(res){
        this.loading(false);
        const {success,valid,model={},} = res;
        if (success && valid) {
            this.setState({
                todoModel:model
            })
        }
    }
    //跳转
    goPage(item,sUrl) {
        if(sUrl){
            this.props.history.push(sUrl);
        }
    }
    renderListItem(item={},inx){
        const sCountryUrl =item.abbreviate?require('../../assets/img/country/'+item.abbreviate + '.png'):"";
        // return (<div className={"mt_16 commonBox whiteBox flex-item-between alignTip cursor-p"} key={inx+"_payItem"} onClick={()=>this.goPage(item)}>
        return (<div className={"mt_16 commonBox whiteBox flex-item-between alignTip"} key={inx+"_payItem"}>
            <div>
                <div>
                    {/* 定金 : DEPOSIT_OUT 尾款:TWO_TAIL_OUT 全款:FULL_GOODS_COST */}
                    <span className={`mr_8 ${item.bizType=='DEPOSIT_OUT'?"labelRed":"labelOrange"}`}>{item.remark}</span>
                    <span className={"fw_700 lineH_24"}>{item.bizCode}</span>
                </div>
                <div className={"fw_500 mt_4 lineH_24"}>
                    {item.abbreviate?<img className="mr_12" src={sCountryUrl.default} width={24} />:null}
                    {item.buyerCode}
                </div>
                <div className={"black45 lineH_18"}>{item.buyerName}</div>
                <div className={"fw_500 color_FB7321 mt_4 lineH_21"}>{item.happenTime?dayjs(item.happenTime).format("YYYY-MM-DD HH:mm:ss"): "-"}</div>
            </div>
            <div className={"textRight"}>
                <div className={"fw_700"}>{!isEmpty(item.marginAmount)?symbolMoneyUtil(item.marginAmount, item.currencySymbol):'-'}</div>
                <div className={"black45"}>
                    <span className={"mr_6"}>{Lang({ id: "YuE", default:'余额' })}</span>
                    {!isEmpty(item.balanceAfter)?symbolMoneyUtil(item.balanceAfter, item.currencySymbol):'-'}</div>
            </div>
        </div>)
    }
    renderPayItem(item,key,url){
        return (<div className={"lineH_30 flex-item-ver-center cursor-p"} key={key} onClick={()=>this.goPage(item,url)}>
            <i className="ri-time-line black33"></i>
            <span className={"ml_4 mr_4"}>{item.createTime?dayjs(item.createTime).format("YYYY-MM-DD"): "-"}</span>
            <span className={"font-main2"}>{item.code}</span>
        </div>)
    }
    componentWillMount() {
        this.getTodo()
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const {loading=false,todoModel={}} = this.state;
        // 默认都有
        const hadPermi = true;
        return (hadPermi?<Spin spinning={loading}>
            <div className="dopIndexWrap black89 font_14 flex-item">
                <div className={"left flex-1"}>
                    <div className={"commonBox pinkBox mb_16"}>
                        <div className={"font_18 fw_500 lineH_27"}>{Lang({ id: "ShiXiangDaiBan", default:'事项待办' })}</div>
                        <div className={"mt_4 flex-item halfBox flexHeight"}>
                            <div className={"halfItem"}>
                                <div className={"black66 lineH_21"}>{Lang({id:'TuiKuanChuLi',default:'退款处理'})}</div>
                                <div className={"font_16 fw_700 lineH_24 black89"}>{todoModel.refundBankCardCount||0}</div>
                                {todoModel.refundBankCardList&&todoModel.refundBankCardList.length>0?<div className={"borderTopBox mt_8"}>
                                    {todoModel.refundBankCardList.map((item,inx)=>this.renderPayItem(item,inx+'_toPay','/financeManagement/refundStatics'))}
                                </div>:null}
                            </div>
                            <div className={"halfItem"}>
                                <div className={"black66 lineH_21"}>{Lang({id:'TuiHuiQianBaoJiLu',default:'退回钱包记录'})}</div>
                                <div className={"font_16 fw_700 lineH_24 black89"}>{todoModel.refundWalletCount||0}</div>

                                {todoModel.refundWalletList&&todoModel.refundWalletList.length>0?<div className={"borderTopBox mt_8"}>
                                    {todoModel.refundWalletList.map((item,inx)=>this.renderPayItem(item,inx+'_toConf','/financeManagement/refundConfirmation'))}
                                </div>:null}
                            </div>
                        </div>
                    </div>
                    {/* 资金核销 */}
                    <div className={"commonBox purpleBox mb_16"}>
                         <div className={"font_18 fw_500 lineH_27 flex-item-between"}>{Lang({ id: "ZiJinHeXiao", default:'资金核销' })}
                        <span className={"font-main2 cursor-p font_14"} onClick={()=>this.goPage(null,"/financeManagement/customerBalance")}>{Lang({ id: "GengDuo", default:'更多' })}</span>
                        </div>
                        {todoModel.poWalletItemList&&todoModel.poWalletItemList.length>0?<div>
                            {todoModel.poWalletItemList.map((item,inx)=>this.renderListItem(item,inx))}
                        </div>:null}
                    </div>
                </div>
                <div className={"rightDealt commonBox ml_14"} style={{textAlign: 'center', paddingTop: '35vh'}}>
                    <img src={"https://oss.essaone.com/bf81d637-d196-436d-bb65-a718b83046b1.png"} />
                </div>
            </div>
        </Spin>:<div className="black89 pt_40 text-center">
            <img src={"https://oss.essaone.com/ba0bc74b-252d-4cba-82b1-f887c57f93fb.jpg"} />
        </div>);
    }
}